import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ADSENSE_CLIENT } from 'config/adsense.config';
import { AdSenseContainer } from './styles';

declare global {
  interface Window {
    adsbygoogle: Record<string, unknown>[];
  }
}

type AdSenseProps = {
  slot: string;
  format?: 'auto' | 'fluid' | 'rectangle' | 'vertical' | 'horizontal';
  fullWidthResponsive?: boolean;
};

const AdSense = ({
  slot,
  format = 'auto',
  fullWidthResponsive = true,
}: AdSenseProps) => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!slot) {
      return;
    }

    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      // AdSense 스크립트 미로드 시 무시
    }
  }, [slot, pathname]);

  if (!slot) {
    return null;
  }

  return (
    <AdSenseContainer aria-hidden='true'>
      <ins
        key={`${pathname}-${slot}`}
        className='adsbygoogle'
        style={{ display: 'block' }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={fullWidthResponsive ? 'true' : 'false'}
      />
    </AdSenseContainer>
  );
};

export default AdSense;
